import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { inject } from '@angular/core';
import { filter, map, take } from 'rxjs';
import { authFeature } from '../../features/auth/state';

export const gradeCorrectionAdminGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);
  return store.select(authFeature.selectPermissionsLoaded).pipe(
    filter(Boolean),
    take(1),
    map(() =>
      store
        .selectSignal(authFeature.selectPermissions)()
        .includes('academic.grade_corrections.manage')
        ? true
        : router.createUrlTree(['/dashboard']),
    ),
  );
};
